export const checkIfGoogleSheetUrl = (url: string) => {
  if (!url || typeof url !== "string") {
    return false;
  }
  return url.startsWith("https://docs.google.com/spreadsheets/");
};
